/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';
import { PassportLoginComponent } from '../login/login.component';
import { BottomSheetConfig } from 'src/app/interfaces/mat.interface';
import { PassportIconComponent } from 'src/app/shared/icons/passport.component';
import { AuthService } from 'src/app/auth/services';
import { GamificationService } from '../../services';
import { PassportPopUpComponent } from '../popup/popup.component';
import { BreakpointsService, LocalStorageService, MatDialogService } from 'src/app/services';

@Component({
  selector: "app-passport-fab",
  imports: [
    CommonModule,
    TranslateModule,
    PassportIconComponent
  ],  
  standalone: true,
  templateUrl: "./fab-button.component.html",
  styleUrls: ["./fab-button.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None
})

export class PassportFabButtonComponent {
    private matBottomSheetService: MatBottomSheetService = inject(MatBottomSheetService);
    private authService: AuthService = inject(AuthService);
    private _gamificationService = inject(GamificationService);
    private _localStorageService = inject(LocalStorageService);
    private _breakpointsService = inject(BreakpointsService);
    private _matDialogService = inject(MatDialogService);
    
    private _user = this.authService.user;
    protected passportEnabled =  this._gamificationService.passportsEnabled;
    private _buttomSheet = this._gamificationService.passportBottomSheet;
    private _passportPopup = this._gamificationService.passportPopup;
    protected isMobile = this._breakpointsService.isMobile;

    protected async handleClick(): Promise<void> {
      // Desactivate the pop up
      this._localStorageService.setItem('pop-up-actived', false);

      if (!this.isMobile()){
        await this._matDialogService.openMatDialog({
          component: PassportPopUpComponent,
          data: this._passportPopup(),
          panelClass: 'passport-popup-dialog',
        });
        return;
      }

      if (!this._user()){
        this.openPassportLoginBottomSheet();
        return;
      }
      this.openPassportAddStampBottomSheet();
    }

    private async openPassportLoginBottomSheet() {
      const bottomSheetConfig: BottomSheetConfig<PassportLoginComponent, any> = {
          component: PassportLoginComponent,
          data: this._buttomSheet(),
          panelClass: 'passport-login-bottom-sheet'
      };
      
      await this.matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
    }

    private async openPassportAddStampBottomSheet() {
      // HRS-3045: el escáner QR (@zxing) se descarga solo al pedir "añadir sello".
      const { AddBadgeComponent } = await import('../add-badge/add-badge.component');
      await this.matBottomSheetService.openMatBottomSheet({
          component: AddBadgeComponent,
          panelClass: 'passport-add-stamp-bottom-sheet'
      });
    }
}
